
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import messages from './local/index';

const STORAGE_KEY = 'orvanthe_lang';
const SUPPORTED = ['en', 'pl', 'de', 'fr', 'es', 'it'];

const savedLang = localStorage.getItem(STORAGE_KEY);
const initialLang = savedLang && SUPPORTED.includes(savedLang) ? savedLang : 'en';

i18n
  .use(initReactI18next)
  .init({
    lng: initialLang,
    fallbackLng: 'en',
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
  });

// Sync html lang attribute on init
document.documentElement.lang = initialLang;

export default i18n;
